export default "__VITE_ASSET__DkR79AzE__"